const LANE_TAG_PRIORITY = {
  prospects: ["Warm", "Webinar Attended", "Webinar Registered", "Webinar Invited", "Prospect", "Parenting", "Marriage", "Career"],
  "dad-partners": ["Dad Partners Founding Forty Joined", "Member", "Parenting", "Marriage", "Career"],
  "guide-partners": ["Scheduled", "Active", "Invited", "Onboarding Sent"],
  "support-partners": ["paused", "active", "watch", "Direct contact", "sync issue"],
  "super-fans": ["Referral", "Sharing", "Comments", "Cooling", "Wife"],
  "advisory-partners": ["Packet prep", "Pattern-seeing", "Grounding risk"],
  operations: ["financial", "system", "reporting", "delivery", "marketing"],
};

const getTagPriority = (lane, tag) => {
  const priorities = LANE_TAG_PRIORITY[lane] || [];
  const exactIndex = priorities.indexOf(tag);
  if (exactIndex >= 0) return exactIndex;
  const lowercaseIndex = priorities.findIndex((entry) => entry.toLowerCase() === String(tag || "").toLowerCase());
  return lowercaseIndex >= 0 ? lowercaseIndex : 99;
};

export const orderDetailTagsForItem = (item) =>
  (item.detail_tags || [])
    .slice()
    .sort((left, right) => {
      const leftPriority = getTagPriority(item.lane, left);
      const rightPriority = getTagPriority(item.lane, right);
      if (leftPriority !== rightPriority) return leftPriority - rightPriority;
      return String(left).localeCompare(String(right));
    });

export const getLanePriorityScore = (item) => {
  switch (item.lane) {
    case "prospects":
      return (
        (item.warmth_label === "Warm" ? 40 : 0) +
        (item.relationship_stage_label === "Webinar Attended" ? 30 : 0) +
        (item.relationship_stage_label === "Webinar Registered" ? 20 : 0) +
        (item.dominant_pain_area ? 10 : 0)
      );
    case "dad-partners":
      return (
        (item.relationship_stage_label === "Dad Partners Founding Forty Joined" ? 30 : 0) +
        (/quiet|preach|culture/i.test(`${item.reason} ${item.notes}`) ? 25 : 0) +
        (item.dominant_pain_area ? 8 : 0)
      );
    case "guide-partners":
      return (
        (item.guide_status_label === "Scheduled" ? 35 : 0) +
        (item.guide_status_label === "Active" ? 20 : 0) +
        (item.scheduled_date_label ? 15 : 0)
      );
    case "support-partners":
      return (
        (item.support_status_label === "paused" ? 35 : 0) +
        (item.contact_label ? 12 : 0) +
        (/sync|quiet/i.test(`${item.reason} ${item.notes}`) ? 10 : 0)
      );
    case "super-fans":
      return (
        (item.amplification_label === "Referral" ? 30 : 0) +
        (item.relationship_label === "Wife" ? 15 : 0) +
        (/asked how to help|reached out/i.test(`${item.reason} ${item.notes}`) ? 20 : 0)
      );
    case "advisory-partners":
      return (
        (item.advisory_signal_label === "Packet prep" ? 30 : 0) +
        (item.advisory_signal_label === "Pattern-seeing" ? 18 : 0) +
        (/grounding/i.test(`${item.reason} ${item.notes}`) ? 15 : 0)
      );
    case "operations":
      return (
        (item.type === "financial" ? 30 : 0) +
        (item.type === "system" ? 22 : 0) +
        (item.type === "delivery" ? 18 : 0)
      );
    default:
      return 0;
  }
};

export const sortItemsForLane = (items = [], laneId = "") =>
  items.slice().sort((left, right) => {
    const leftFlag = left.is_kevin_flagged ? 1 : 0;
    const rightFlag = right.is_kevin_flagged ? 1 : 0;
    if (leftFlag !== rightFlag) return rightFlag - leftFlag;
    const leftAttentionBoost = left.attention_priority_boost || 0;
    const rightAttentionBoost = right.attention_priority_boost || 0;
    if (leftAttentionBoost !== rightAttentionBoost) return rightAttentionBoost - leftAttentionBoost;
    const leftPriority = getLanePriorityScore({ ...left, lane: laneId || left.lane });
    const rightPriority = getLanePriorityScore({ ...right, lane: laneId || right.lane });
    if (leftPriority !== rightPriority) return rightPriority - leftPriority;
    const dateCompare = (left.follow_up_date || "").localeCompare(right.follow_up_date || "");
    if (dateCompare !== 0) return dateCompare;
    return (right.last_meaningful_movement || "").localeCompare(left.last_meaningful_movement || "");
  });

export const sortItemsGlobally = (items = []) =>
  items.slice().sort((left, right) => {
    const leftFlag = left.is_kevin_flagged ? 1 : 0;
    const rightFlag = right.is_kevin_flagged ? 1 : 0;
    if (leftFlag !== rightFlag) return rightFlag - leftFlag;
    const leftAttentionBoost = left.attention_priority_boost || 0;
    const rightAttentionBoost = right.attention_priority_boost || 0;
    if (leftAttentionBoost !== rightAttentionBoost) return rightAttentionBoost - leftAttentionBoost;
    const leftPriority = getLanePriorityScore(left);
    const rightPriority = getLanePriorityScore(right);
    if (leftPriority !== rightPriority) return rightPriority - leftPriority;
    const dateCompare = (left.follow_up_date || "").localeCompare(right.follow_up_date || "");
    if (dateCompare !== 0) return dateCompare;
    return (right.last_meaningful_movement || "").localeCompare(left.last_meaningful_movement || "");
  });
